import './AboutPage.css';
import clintimg1 from '../pics/clint-portugal.jpg';
const AboutPage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <h1>About Loveario</h1>
          <p>Data platform engineering and cloud architecture consultancy</p>
        </div>
      </section>

      {/* About Content */}
      <section className="about-content">
        <div className="container">
          <div className="about-section">
            <h2>Our Story</h2>
            <figure className="headshot-figure">
              <img src={clintimg1} alt="Clint Grove founder of Loveario" className="headshot" />
              <figcaption className="headshot-name">Clint Grove</figcaption>
            </figure>
           <p>
              Loveario was founded by Clint Grove in 2025 on years of hands-on experience delivering data platforms
              at enterprise scale — from leading cloud data warehouse migrations at Microsoft
              to building organisation-wide BI frameworks at Mott MacDonald. We bring deep
              technical expertise and real-world delivery know-how to every engagement.
            </p>
            <p>
              We specialise in Azure cloud data architecture, Databricks and Fabric
              Lakehouse implementations, Power BI analytics, and DevOps-driven Infrastructure
              as Code. Whether you need a full platform build or targeted consulting, we
              help organisations unlock the value in their data.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Mission</h2>
            <p>
              To help organisations architect, build and operate modern data platforms
              that turn raw data into trusted insights — delivered with engineering
              rigour, cloud-native best practices and a relentless focus on business
              outcomes.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Values</h2>
            <div className="values-grid">
              <div className="value-card">
                <h3>Engineering Excellence</h3>
                <p>Production-grade solutions built with IaC, CI/CD and automated testing
                  — no shortcuts.</p>
              </div>
              <div className="value-card">
                <h3>Reliability</h3>
                <p>We deliver on time, on scope, and stand behind the platforms we build.</p>
              </div>
              <div className="value-card">
                <h3>Transparency</h3>
                <p>Clear communication, honest estimates and knowledge transfer are
                  baked into every engagement.</p>
              </div>
              <div className="value-card">
                <h3>Customer Focus</h3>
                <p>Your business goals drive every design decision. We listen first,
                  then architect.</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>Why Clients Trust Us</h2>
            <p>
              With experience spanning Microsoft's Industry Solutions Delivery team and
              large-scale consultancies, we understand the full lifecycle of a data platform
              — from strategy and architecture through to deployment, governance and
              ongoing operations.
            </p>
            <p>
              Our track record includes cloud data warehouse migrations to Lakehouse on
              Databricks, enterprise Power BI Embedded frameworks serving external clients
              globally, and managing Azure infrastructure with Bicep IaC and DevOps
              pipelines. We're not just advisors — we build and ship.
            </p>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section className="team-section">
        <div className="container">
          <h2 style={{ textAlign: 'center', color: 'var(--text-dark)' }}>What We Bring</h2>
          <div className="team-grid">
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>🏗️</div>
              <h3>Architecture & Strategy</h3>
              <p>Data strategy, cloud architecture design and solution consulting. We
                engage from pre-sales through to production hand-over.</p>
            </div>
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>⚙️</div>
              <h3>Build & Deliver</h3>
              <p>Hands-on engineering in PySpark, Data Factory, SQL Server, Databricks,
                Fabric and Fabric — backed by Azure DevOps and Bicep IaC.</p>
            </div>
            <div className="team-member">
              <div style={{ fontSize: '3rem', marginBottom: '0.5rem' }}>📊</div>
              <h3>Analytics & BI</h3>
              <p>Power BI Premium and Embedded development, geo-distributed gateway
                management, RBAC and Azure AD integration.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
